import React from "react";
import ReferenceArea from "./ReferenceArea"
import SearchAppProvider from "../../../appProviders/FinancialAppProvider"

const ReferenceAreaContainer = props => <SearchAppProvider><ReferenceArea {...props}/></SearchAppProvider>;
export default ReferenceAreaContainer;
